class ResultToolResultSet
{
    calculate = (results) => {
        Object.keys(results).map((result, index) => {
            if (index > 5) {
                return {};
            }

            results[index]['OK'] = Math.round((results[index]['OK'] / results['COUNT']) * 100);
            results[index]['NOK'] = Math.round((results[index]['NOK'] / results['COUNT']) * 100);

            return {};
        })

        return results
    };

    getEmptyResults = () => ({
            0: {"OK": 0, "NOK": 0},
            1: {"OK": 0, "NOK": 0},
            2: {"OK": 0, "NOK": 0},
            3: {"OK": 0, "NOK": 0},
            4: {"OK": 0, "NOK": 0},
            5: {"OK": 0, "NOK": 0},
            'COUNT': 0,
        }
    );

    map = (response) => response.answers.map((answer) => answer.answer);

    parse = (resultSet) => {
        let results = this.getEmptyResults();

        resultSet.map((item) => {
            item = JSON.parse(item);

            item.answers.map(({step, answer}) => {
                results[step][answer]++;
                return {};
            })

            results['COUNT']++;

            return item;
        });

        return results;
    };

    fromResponse = (response) => this.calculate(this.parse(this.map(response)));
}

export default new ResultToolResultSet();
